import styled from 'styled-components';

const FormSuccessWrapper = styled.div`
  margin-top: ${({theme}) => theme.spacing.xsmall};
  margin-bottom: ${({theme}) => theme.spacing.xsmall};
  color: ${({theme}) => theme.colors.green};
  font-weight: bold;
  font-size: ${({theme}) => theme.fontSize.medium};
`;

const FormErrorWrapper = styled.div`
  margin-top: ${({theme}) => theme.spacing.xsmall};
  margin-bottom: ${({theme}) => theme.spacing.xsmall};
  color: ${({theme}) => theme.colors.red};
  font-weight: bold;
  font-size: ${({theme}) => theme.fontSize.medium};
`;

const FormSendingWrapper = styled.div`
  margin-top: ${({theme}) => theme.spacing.xsmall};
  margin-bottom: ${({theme}) => theme.spacing.xsmall};
  font-weight: bold;
  font-size: ${({theme}) => theme.fontSize.medium};
`;

export const FormSuccess = ({children}) => <FormSuccessWrapper>{children}</FormSuccessWrapper>;

export const FormError = ({children}) => <FormErrorWrapper>{children}</FormErrorWrapper>;

export const FormSending = ({children}) => <FormSendingWrapper>{children}</FormSendingWrapper>;
